import type {
  V1SendModelRequest,
  V1SendModelResponse,
  WealthportfolioManagementmodelsv1BatchGetModelsRequest,
  WealthportfolioManagementmodelsv1BatchGetModelsResponse,
} from '@blk/aladdin-graph-client-axios-internal/wealth/portfolio_management/models/v1/model_api';
import { awPortfolioManagementApi } from './Base';

const MODELS_PATH = 'models/v1/models';

export function postSendModels(request: V1SendModelRequest) {
  const path = `${MODELS_PATH}:send`;
  return awPortfolioManagementApi.post<V1SendModelResponse>(path, request);
}

export function postBatchGetModelsV2(getModelsRequest: WealthportfolioManagementmodelsv1BatchGetModelsRequest) {
  const path = `${MODELS_PATH}:batchGet`;
  return awPortfolioManagementApi.post<WealthportfolioManagementmodelsv1BatchGetModelsResponse>(path, getModelsRequest);
}
